import axios from 'axios';
import { store } from "../NextApp";
import { API_REQUEST, TICKETING_SYS_BASE_URL, PERAMAL_INTEGRATOR_BASE_URL, VOYAGER_INTEGRATOR_BASE_URL } from '../constants/constants';
import { userSignOut } from '../appRedux/actions';

let mainInstance = axios.create({
  headers: {
    'Content-Type': 'application/json',
  }
});

export const ticketingSysInstance = axios.create({
  baseURL: TICKETING_SYS_BASE_URL,
  headers: { "Content-Type": "application/json" }
});

export const peramalIntegratorInstance = axios.create({
  baseURL: PERAMAL_INTEGRATOR_BASE_URL,
  headers: { "Content-Type": "application/json" }
});

export const voyagerIntegratorInstance = axios.create({
  baseURL: VOYAGER_INTEGRATOR_BASE_URL,
  headers: { "Content-Type": "application/json" }
});

mainInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401 && !(error.config && error.config.skipAuthSignOut)) {
      store.dispatch(userSignOut());
    }
    return Promise.reject(error);
  },
);

export default mainInstance;
